<template>
  <el-dialog
    :title="modalType == 'add' ? '添加产品' : '编辑产品'"
    :visible.sync="visible"
    width="900px"
    :close-on-click-modal="false"
    @closed="clearForm"
  >
    <el-form
      :model="ruleForm"
      ref="ruleForm"
      label-width="120px"
      class="modal-form"
    >
      <el-form-item
        prop="afid"
        :rules="[
          { required: true, message: '请输入唯一标识', trigger: 'blur' },
        ]"
        label="唯一标识："
      >
        <el-input
          type="text"
          v-model.trim="ruleForm.afid"
          autocomplete="off"
          :disabled="modalType == 'add' ? false : true"
          @change="handleAFID"
          placeholder="请输入唯一标识"
        ></el-input>
      </el-form-item>
      <el-form-item prop="afDevKey" label="AF_Dev key：">
        <el-input
          type="text"
          v-model.trim="ruleForm.afDevKey"
          autocomplete="off"
          placeholder="请输入AF_Dev key"
        ></el-input>
      </el-form-item>
      <el-form-item
        label="产品名称："
        prop="appName"
        :rules="[
          { required: true, message: '请输入产品名称', trigger: 'blur' },
        ]"
      >
        <el-input
          placeholder="请输入产品名称"
          v-model.trim="ruleForm.appName"
        ></el-input>
      </el-form-item>
      <el-form-item
        label="发布市场："
        prop="publishMarket"
        :rules="[
          { required: false, message: '请选择发布市场', trigger: 'change' },
        ]"
      >
        <el-select
          style="width: 100%"
          v-model="ruleForm.publishMarket"
          placeholder="请选择发布市场"
        >
          <el-option
            v-for="item in publishMarketList"
            :key="item.publishMarket"
            :label="item.publishMarketName"
            :value="item.publishMarket"
          >
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item
        label="平台类型："
        prop="publishPlatform"
        :rules="[
          { required: true, message: '请选择平台类型', trigger: 'change' },
        ]"
      >
        <el-select
          style="width: 100%"
          v-model="ruleForm.publishPlatform"
          placeholder="请选择平台类型"
        >
          <el-option
            v-for="item in marketTypeList"
            :key="item.refId"
            :label="item.name"
            :value="item.refId"
          >
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item
        label="DBTID："
        prop="dbtId"
        :rules="[
          { required: false, message: '请输入DBTID', trigger: 'change' },
        ]"
      >
        <el-input placeholder="请输入DBTID" v-model="ruleForm.dbtId"></el-input>
      </el-form-item>
      <el-form-item label="投放渠道：" prop="mediaSourceList">
        <el-select
          filterable
          multiple
          class="multiple-select"
          collapse-tags
          style="width: 100%"
          v-model="ruleForm.mediaSourceList"
          placeholder="请选择投放渠道"
        >
          <el-option
            v-for="item in mediaSourceOptions"
            :key="item"
            :label="item"
            :value="item"
          >
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="原始ID：" prop="originId">
        <el-input
          placeholder="请输入原始ID"
          v-model.trim="ruleForm.originId"
        ></el-input>
      </el-form-item>
      <el-form-item label="投放名：" prop="launchName">
        <el-input
          placeholder="请输入投放名"
          v-model.trim="ruleForm.launchName"
        ></el-input>
      </el-form-item>

      <el-form-item label="主体类别：" prop="deliverySubType">
        <el-select
          style="width: 100%"
          v-model="ruleForm.deliverySubType"
          placeholder="请选择主体类别"
        >
          <el-option label="公司" :value="1"></el-option>
          <el-option label="个人" :value="2"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="投放主体：" prop="deliverySubId">
        <el-select
          style="width: 100%"
          v-model="ruleForm.deliverySubId"
          placeholder="请选择投放主体"
        >
          <el-option
            v-for="item in deliverySubList"
            :key="item.id"
            :label="item.deliveryName"
            :value="item.id"
          >
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="变现形式：" prop="realizationType">
        <el-select
          style="width: 100%"
          v-model="ruleForm.realizationType"
          placeholder="请选择变现形式"
        >
          <el-option label="IAA" :value="1"></el-option>
          <el-option label="IAP" :value="2"></el-option>
          <el-option label="IAA+IAP" :value="3"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="af账号ID：" prop="afAccount">
        <el-select
          style="width: 100%"
          v-model="ruleForm.afAccount"
          placeholder="请选择af账号ID"
        >
          <el-option
            v-for="item of afAccountList"
            :label="item.biKey"
            :value="item.id"
            :key="item.id"
          ></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="引力appid：" prop="gravityAppId">
        <el-input
          placeholder="请输入引力appid"
          v-model.trim="ruleForm.gravityAppId"
        ></el-input>
      </el-form-item>
      <el-form-item label="引力appkey：" prop="gravityAppKey">
        <el-select
          style="width: 100%"
          v-model="ruleForm.gravityAppKey"
          placeholder="请选择引力appkey"
        >
          <el-option
            v-for="item of appKeyList"
            :label="item.paraName"
            :value="item.id"
            :key="item.id"
          ></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="备注：" prop="mark">
        <el-input
          type="textarea"
          placeholder="请输入备注"
          v-model.trim="ruleForm.mark"
          maxlength="100"
          show-word-limit
          :autosize="{ minRows: 3 }"
        ></el-input>
      </el-form-item>
      <el-form-item label="推广状态：" prop="popuStatus">
        <el-switch
          v-model="ruleForm.popuStatus"
          :active-value="true"
          :inactive-value="false"
        ></el-switch>
      </el-form-item>
      <el-form-item label="仅接受引力数据：" prop="isGravity" class="yl-data">
        <div class="flex" style="align-items: center; height: 40px">
          <el-switch
            v-model="ruleForm.isGravity"
            :active-value="1"
            :inactive-value="0"
            style="margin-right: 12px"
          ></el-switch>
          <div v-if="ruleForm.isGravity == 1" class="flex">
            <el-date-picker
              v-model="ruleForm.gravityStartDate"
              format="yyyy-MM-dd"
              value-format="yyyy-MM-dd"
              type="date"
              placeholder="选择日期"
            >
            </el-date-picker>
            <span style="margin-left: 4px; color: #999">起</span>
          </div>
        </div>
      </el-form-item>
    </el-form>
    <span slot="footer" class="dialog-footer">
      <el-button @click="cancelForm('ruleForm')">取 消</el-button>
      <el-button
        :loading="btnLoading"
        type="primary"
        @click="saveForm('ruleForm')"
        >确 定</el-button
      >
    </span>
  </el-dialog>
</template>

<script>
import {
  getTagPropertySelectList,
  getPublishMarketsList,
} from "@/api/property";
import { getGravitationTable } from "@/api/gravitation";
import {
  getmediaSourceFetch,
  getDbtIdByAfIdFetch,
  getParamSettingListFetch,
  getDeliverySubList,
  addProductTableItemFetch,
  updateProductTableItemFetch,
} from "@/api/api";
import Vue from "vue";
export default {
  data() {
    return {
      ruleForm: {},
      modalType: "",
      visible: false,
      publishMarketList: [],
      marketTypeList: [],
      mediaSourceOptions: [],
      afAccountList: [],
      btnLoading: false,
      deliverySubList: [],
      // 引力appkey列表
      appKeyList: [],
    };
  },
  props: {
    addormodify: String,
  },
  mounted() {},
  methods: {
    getGravitationList() {
      getGravitationTable().then((res) => {
        if (res.code === "0000") {
          this.appKeyList = res.data;
        }
      });
    },
    async showModal(type, data) {
      await this.initSelect();
      this.modalType = type;
      if (type == "add") {
        this.ruleForm = {
          afid: "",
          afDevKey: "",
          appName: "",
          publishMarket: "",
          publishPlatform: "",
          dbtId: "",
          mediaSourceList: [],
          originId: "",
          launchName: "",
          deliverySubType: "",
          deliverySubId: "",
          realizationType: 1,
          afAccount: null,
          mark: "",
          popuStatus: false,
          // 引力appid
          gravityAppId: "",
          // 引力appkey
          gravityAppKey: "",
          isGravity: 0,
          gravityStartDate: "",
        };
      } else {
        this.ruleForm = {
          ...data,
          popuStatus: data.popuStatus == 1 ? true : false,
          id: data.id,
        };
      }
      this.visible = true;
    },
    initSelect() {
      getTagPropertySelectList({ type: 10 }).then((res) => {
        this.marketTypeList = res.data;
      });
      getPublishMarketsList().then((res) => {
        this.publishMarketList = res.data;
      });
      getmediaSourceFetch().then((res) => {
        this.mediaSourceOptions = res.mediaList;
      });
      getParamSettingListFetch().then((res) => {
        if (res.code === "0000") {
          this.afAccountList = res.sysParas;
        }
      });
      // 获取引力appkey列表
      this.getGravitationList();
      getDeliverySubList({
        pageNum: 1,
        pageSize: 99999,
      }).then((res) => {
        this.deliverySubList = res.data.list;
        const findDbtId = this.deliverySubList.find(
          (item) => item.deliveryName == "多比特"
        )?.id;
        if (this.modalType == "add") {
          Vue.set(this.ruleForm, "deliverySubId", findDbtId);
        }
      });
    },
    cancelForm() {
      this.visible = false;
      this.$emit("closeDialogForm");
    },
    handleAFID() {
      getDbtIdByAfIdFetch({ afId: this.ruleForm.afid }).then((res) => {
        if (res.code == "0000") {
          const { dbtId, appName, publishPlatform, mediaSourceList } = res.data;
          Vue.set(this.ruleForm, "dbtId", dbtId);
          Vue.set(this.ruleForm, "appName", appName);
          Vue.set(this.ruleForm, "publishPlatform", publishPlatform);
          Vue.set(this.ruleForm, "publishMarket", publishPlatform);
          Vue.set(this.ruleForm, "mediaSourceList", mediaSourceList);
        }
      });
    },
    saveForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.btnLoading = true;
          const { isGravity, gravityStartDate } = this.ruleForm;
          if (this.modalType == "add") {
            addProductTableItemFetch({
              ...this.ruleForm,
              gravityStartDate: isGravity == 0 ? "" : gravityStartDate,
              popuStatus: this.ruleForm.popuStatus ? 1 : 0,
            }).then((res) => {
              if (res.code == "0000") {
                this.$message.success("新增成功");
                this.visible = false;
                this.$emit("closeDialogForm");
              }
              this.btnLoading = false;
            });
          } else {
            updateProductTableItemFetch({
              ...this.ruleForm,
              gravityStartDate: isGravity == 0 ? "" : gravityStartDate,
              popuStatus: this.ruleForm.popuStatus ? 1 : 0,
            }).then((res) => {
              if (res.code == "0000") {
                this.$message.success("编辑成功");
                this.visible = false;
                this.$emit("closeDialogForm");
              }
              this.btnLoading = false;
            });
          }
        } else {
          return false;
        }
      });
    },
    clearForm() {
      this.$refs.ruleForm.clearValidate();
    },
  },
};
</script>

<style scoped lang="less">
.modal-form {
  display: flex;
  flex-wrap: wrap;
  /deep/ .el-form-item {
    width: 50%;
  }
  .is-required {
    /deep/ .el-form-item__label::before {
      content: "*";
      display: inline-block;
      color: red;
      margin-right: 4px;
    }
  }
  /deep/ .el-input__count {
    line-height: 20px;
    bottom: 1px;
  }
  .multiple-select {
    /deep/ .el-tag.el-tag--info:first-child {
      max-width: 150px;
      overflow: hidden;
      text-overflow: ellipsis;
    }
  }
  .yl-data {
    /deep/ .el-form-item__label {
      width: 130px !important;
    }
  }
}
</style>
